import React from 'react'

const MediaQueryContext = React.createContext({
  mediaQuery: '',
})

export default MediaQueryContext
